export default {
  'app.console.nodata': 'Tidak ada data',
  'app.console.recents': 'Akses Terbaru',
  'app.console.recents.nodata': 'Tidak ada data tersedia. Silakan aktifkan layanan terlebih dahulu',
  'app.console.channel': 'Layanan yang Akan Diaktifkan',
  'app.console.channel.active': 'Layanan telah dibuka',
  'app.console.channel.activateService': 'Mulai',
  'app.console.channel.learnMore': 'Pelajari Lebih Lanjut',
  'app.console.channel.sendNum': 'Terkirim',
  'app.console.channel.targetNum': 'Target',
  'app.console.channel.deliveredNum': 'Terkirim',
  'app.console.channel.clickNum': 'Klik',
  'app.console.channel.readNum': 'Jumlah Dibaca',
  'app.console.channel.sendNumRate': 'Tingkat Terkirim',
  'app.console.channel.deliveredNumRate': 'Tingkat Pengiriman',
  'app.console.channel.clickNumRate': 'CTR',
  'app.console.channel.readNumRate': 'Tingkat Baca',
  'app.console.channel.title1': 'Tren dalam 7 hari terakhir',
  'app.console.channel.title2': 'Konversi dalam 7 hari terakhir',
  'app.console.channel.sendOut': 'Kirim pesan',
  'app.console.channel.start': 'Mulai',
  'app.console.channel.message.activated': 'diaktifkan',
  'app.console.channel.message.apppush':
    'Menyelesaikan proses integrasi SDK dalam waktu hanya 3 menit untuk mencapai push yang cerdas dan akurat, secara efektif meningkatkan aktivitas dan retensi pengguna',
  'app.console.channel.message.email':
    'Menyediakan API pengiriman email yang efisien dan stabil, mendukung konfigurasi IP independen, autentikasi BIMI, dan mengoptimalkan strategi pengiriman untuk meningkatkan tingkat pengiriman melalui umpan balik data yang akurat secara real-time.',
  'app.console.channel.message.sms':
    'Fungsi pesan SMS terintegrasi kami menggabungkan layanan komunikasi seluler tradisional dengan Internet membantu perusahaan menjadi benar-benar global',
  'app.console.channel.message.whatsapp':
    'Gunakan WhatsApp Business API untuk membangun koneksi yang lebih dekat dengan lebih dari dua miliar pengguna global',
  'app.console.channel.message.OTP':
    'EngageLab OTP menyediakan layanan untuk menghasilkan dan memvalidasi kata sandi sekali pakai, mendukung pengiriman multi-saluran melalui WhatsApp, SMS, Voice, dan Email untuk memastikan pengiriman dan konversi yang berhasil.',
  'app.console.channel.message.webpush':
    'Alih-alih mengandalkan aplikasi seluler, Anda dapat mendorong pesan pemasaran dan notifikasi layanan ke pelanggan situs web kapan saja untuk meningkatkan keterlibatan dan konversi pengguna',
  'app.console.channel.message.edm':
    'Instalasi satu klik dan tanpa kode diperlukan, toko Anda dapat dengan mudah melakukan pemasaran email dan menggunakan otomatisasi untuk mendorong pelanggan untuk membeli, dan meningkatkan pendapatan',
  'app.console.channel.message.ma':
    'Layanan otomatisasi pemasaran mendukung mengelola data pengguna, membangun perjalanan pengguna, menggunakan beberapa saluran untuk menjangkau pengguna Anda, dan memberikan pengguna pengalaman yang cepat dan dipersonalisasi.',
  'app.console.channel.message.captcha':
    'CAPTCHA Perilaku, menyelesaikan kerugian bisnis dan risiko keamanan yang disebabkan oleh serangan otomatisasi program skrip mesin.',
  'app.console.channel.message.livedesk':
    'Platform layanan pelanggan yang digerakkan oleh AI yang menangani 90% masalah pelanggan dengan sempurna.',
  'app.console.channel.message.silentauth':
    'Layanan autentikasi diam yang menyediakan solusi verifikasi identitas pengguna yang aman dan mulus.',
  'app.console.channel.flag.email': 'Wawasan Kotak Masuk',
  'app.console.doc': 'REST API Docs',
  'app.console.doc.apppush': 'AppPush Docs',
  'app.console.doc.email': 'Email Docs',
  'app.console.doc.sms': 'SMS Docs',
  'app.console.doc.newsms': 'SMS Docs',
  'app.console.doc.whatsapp': 'WhatsApp  Docs',
  'app.console.doc.webpush': 'WebPush  Docs',
  'app.console.doc.edm': 'EDM  Docs',
  'app.console.doc.otp': 'OTP Docs',
  'app.console.doc.ma': 'Marketing Automation Docs',
  'app.console.doc.captcha': 'CAPTCHA Docs',
  'app.console.doc.livedesk': 'LiveDesk Docs',
  'app.console.doc.silentauth': 'Silent Auth Docs',
  'app.console.manage': 'Pengaturan',
  'app.console.manage.orders': 'Pesanan & Tagihan',
  'app.console.manage.pending': 'Pesanan yang harus dibayar',
  'app.console.manage.supplementary': 'Tagihan yang harus dibayar',
  'app.console.manage.notification': 'Notifikasi',
  'app.console.manage.faq': 'FAQ',
  'app.console.manage.download': 'Unduhan',
  'app.console.channel.verifiedRate': 'Tingkat Pengisian Kembali',
  'app.console.channel.verifiedNum': 'Jumlah Pengisian Kembali',
  'app.console.channel.select.all': 'Semua',
};
